export const layoutOriginTypes = {
  from_user: 'from_user',
  from_optimized: 'from_optimized',
  hybrid: 'hybrid',
  from_active_version: 'from_active_version',
  from_draft_version: 'from_draft_version',
  from_master_planogram: 'from_master_planogram',
  from_branch_copy: 'from_branch_copy',
}

export const excelUploadAvailablity = {
  available: 'available',
  not_available: 'not_available',
}

export const statusTypes = {
  ACTIVE: 'ACTIVE',
  CONFIRMED: 'CONFIRMED',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT',
  CONFIMED: 'CONFIMED',
}

export const defaultPerPage = {
  PER_PAGE: 7,
}

export const connectedStore = {
  SHOW_LIMIT: 10,
}

export const showList= {
PLANOGRAM_LIST  : 1,
SIMULATION_LIST : 2
}

export const planogramTypeList = {
DETAILED_VIEW: 'DETAILED_VIEW',
BY_PLANOGRAM: 'BY_PLANOGRAM',
BY_STORE: 'BY_STORE',
BY_PLANOGRAM_REGION_LEVEL: 'BY_PLANOGRAM_REGION_LEVEL',
BY_PLANOGRAM_DETAILED_VIEW: 'BY_PLANOGRAM_DETAILED_VIEW',
BY_STORE_BRANCH_LEVEL: 'BY_STORE_BRANCH_LEVEL',
BY_STORE_DETAILED_VIEW: 'BY_STORE_DETAILED_VIEW',
}
